import { BP42Action } from '@r1-frontend/bp42/constants/actions';

import { IAction } from '@r1-frontend/shared/types/Redux';

const finalization = (): IAction<BP42Action.Finalization, null> => ({
    type: BP42Action.Finalization,
    payload: null,
});

export default finalization;
